<script>
  import Modal from "../../components/Modal.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { createEventDispatcher } from "svelte"
  import getMoneda, { redondear, dateFormat } from "../../services/moneda.js"
  import Container from "../../components/Container.svelte"

  const dispatch = createEventDispatcher()
  export let cliente
  let isOpenModalDatosLaborales = false
  let laboral_razon_social = ""
  let laboral_ruc = ""
  let laboral_p1 = ""
  let isSettingDatosLaborales = false
  let info_adicional = false

  let laboral_devengue_año = new Date().getFullYear()
  const laboral_años = Array.from(
    { length: 8 },
    (_, index) => laboral_devengue_año - index,
  )
  let laboral_devengue_mes = "01"
  const laboral_meses = [
    { value: "01", name: "Enero" },
    { value: "02", name: "Febrero" },
    { value: "03", name: "Marzo" },
    { value: "04", name: "Abril" },
    { value: "05", name: "Mayo" },
    { value: "06", name: "Junio" },
    { value: "07", name: "Julio" },
    { value: "08", name: "Agosto" },
    { value: "09", name: "Septiembre" },
    { value: "10", name: "Octubre" },
    { value: "11", name: "Noviembre" },
    { value: "12", name: "Diciembre" },
  ]

  const handleAgregarDatosLaborales = () => {
    isOpenModalDatosLaborales = true
  }

  const updateDatosLaborales = async () => {
    if (laboral_razon_social.trim() === "" || laboral_ruc.trim() === "") {
      alert("Por favor, complete todos los campos.")
      return
    }

    // Validación básica de RUC
    if (laboral_ruc.length !== 11 || isNaN(laboral_ruc)) {
      alert("Por favor, ingrese un RUC válido.")
      return
    }

    // Validación básica de Ingreso
    if (info_adicional && isNaN(laboral_p1)) {
      alert("Por favor, ingrese valores numéricos válidos para Ingreso.")
      return
    }

    isSettingDatosLaborales = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateDatosLaborales",
        id: cliente.id,
        laboral_razon_social,
        laboral_ruc,
        laboral_devengue: `${laboral_devengue_año}${laboral_devengue_mes}`,
        laboral_p1,
        info_adicional: info_adicional ? 1 : 0,
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      laboral_razon_social = ""
      laboral_ruc = ""
      laboral_p1 = ""
      isOpenModalDatosLaborales = false
      dispatch("update")
    } else {
      console.error("Error al actualizar datos laborales:", data.message)
    }
    isSettingDatosLaborales = false
  }

  const buscarEmpresa = async () => {
    // Verificar que RUC tenga 11 dígitos, que sean números y que incie con 10 o 20 o 15 o 17
    if (
      laboral_ruc.length !== 11 ||
      isNaN(laboral_ruc) ||
      !["10", "20", "15", "17"].includes(laboral_ruc.substring(0, 2))
    ) {
      laboral_razon_social = ""
      return
    }

    let session_key = $user.session_key
    let url = `${BASE_URL}empresa.php?ruc=${laboral_ruc}&session_key=${session_key}`

    const response = await fetch(url)
    const resp = await response.json()
    if (resp.status == "ok") {
      laboral_razon_social = resp.data.razonsocial
    } else {
      laboral_razon_social = ""
    }
  }
</script>

<Container>
  <div class="d-flex justify-content-between align-items-center">
    <h6 class="text-start">
      <i class="bi bi-briefcase fg-secondary me-3"></i> Datos laborales
    </h6>
    <button
      class="btn btn-sm fg-primary"
      on:click={handleAgregarDatosLaborales}
      ><i class="bi bi-pencil-square"></i></button
    >
  </div>
  <div class="table-responsive">
    <table class="table table-striped table-sm small">
      <tbody>
        <tr>
          <td class="fg-secondary">Razón social</td>
          <td>{cliente.laboral_razon_social}</td>
        </tr>
        <tr>
          <td class="fg-secondary">RUC</td>
          <td>{cliente.laboral_ruc}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Devengue</td>
          <td>{cliente.laboral_devengue}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Ingreso</td>
          <td>
            {#if cliente.laboral_devengue != ""}
              {getMoneda(cliente.laboral_p1)}
            {/if}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</Container>

<Modal
  isOpen={isOpenModalDatosLaborales}
  on:close={() => (isOpenModalDatosLaborales = false)}
  title="Agregar datos laborales"
>
  <div class="mb-3">
    <label for="laboral_ruc" class="form-label">RUC</label>
    <input
      type="text"
      id="laboral_ruc"
      class="form-control form-control-sm"
      bind:value={laboral_ruc}
      on:input={buscarEmpresa}
    />
  </div>
  <div class="mb-3">
    <label for="laboral_razon_social" class="form-label">Razón social</label>
    <input
      type="text"
      id="laboral_razon_social"
      class="form-control form-control-sm"
      disabled
      bind:value={laboral_razon_social}
    />
  </div>
  <fieldset>
    <legend>
      Información adicional
      <input
        type="checkbox"
        class="check mx-3"
        bind:checked={info_adicional}
      />
    </legend>
    <div class="mb-3 {info_adicional ? '' : 'd-none'}">
      <label for="laboral_devengue_año" class="form-label">Devengue</label>
      <div class="row">
        <div class="col-4">
          <select
            id="laboral_devengue_año"
            class="form-control form-control-sm"
            bind:value={laboral_devengue_año}
          >
            {#each laboral_años as año}
              <option value={año}>{año}</option>
            {/each}
          </select>
        </div>
        <div class="col-8">
          <select
            id="laboral_devengue_mes"
            class="form-control form-control-sm"
            bind:value={laboral_devengue_mes}
          >
            {#each laboral_meses as mes}
              <option value={mes.value}>{mes.name}</option>
            {/each}
          </select>
        </div>
      </div>
    </div>
    <div class="mb-3 {info_adicional ? '' : 'd-none'}">
      <label for="laboral_p1" class="form-label">Ingreso</label>
      <input
        type="text"
        id="laboral_p1"
        class="form-control form-control-sm"
        bind:value={laboral_p1}
      />
    </div>
  </fieldset>
  <div class="my-3 text-end">
    {#if isSettingDatosLaborales}
      <button class="btn btn-solid theme-primary btn-sm disabled" disabled
        >Agregando...</button
      >
    {:else}
      <button class="btn btn-solid theme-primary btn-sm" on:click={updateDatosLaborales}
        >Agregar</button
      >
    {/if}
  </div>
</Modal>

<style>
  fieldset,
  legend {
    all: revert;
  }

  legend {
    color: #6c757d;
  }

  fieldset {
    border: 1px solid #dee2e6;
    border-radius: 5px;
  }
</style>
